export default __webpack_public_path__ + "static/media/Certificate under 74 (5).9a3dbf13.pdf";